import { Box, OutlinedInput } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Colors } from '~/libs/mui/theme'
import { SubmitButton } from './SubmitButton'

interface CommentInputFormInputs {
  comment: string
}

interface CommentInputFormProps {
  placeholder?: 'post_review' | 'reply'
  onSubmitComment: (comment: string) => Promise<void>
}

export function CommentInputForm({
  placeholder = 'reply',
  onSubmitComment,
}: CommentInputFormProps): JSX.Element {
  const { t } = useTranslation()
  const {
    reset,
    control,
    formState: { isValid },
    handleSubmit,
  } = useForm<CommentInputFormInputs>({
    mode: 'onBlur',
    defaultValues: { comment: '' },
  })

  const onSubmit = handleSubmit(({ comment }) => {
    onSubmitComment(comment)
    reset()
  })

  return (
    <Box component='form' onSubmit={onSubmit}>
      <Controller
        name='comment'
        control={control}
        render={({ field: props }) => (
          <OutlinedInput
            {...props}
            multiline
            fullWidth
            placeholder={t(placeholder)}
            endAdornment={<SubmitButton isSubmittable={isValid} />}
            sx={{
              padding: '6px 6px 6px 12px',
              border: `1px solid ${Colors.color91908F}`,
            }}
          />
        )}
        rules={{ required: true, maxLength: 600 }}
      />
    </Box>
  )
}
